import { useEffect } from "react";

import { setActivityRecording } from "@/lib/analytics";
import { useSession } from "@/lib/auth";

export function ActivityRecorder() {
  const user = useSession().data?.user;
  const isMember = Boolean(user && !user.is_platform_admin && user.organization_id);

  useEffect(() => {
    setActivityRecording(isMember);
  }, [isMember]);

  return null;
}
